import { HeaderLogo } from 'components/icons/menu-header-logo'
import { SettingsIcon } from 'components/icons/settings'
import { MenuBrush } from 'components/icons/menu-brush'
import React from 'react'
import * as Types from '../types'
import * as Utils from '../utils'

export const REDUX_STORE_HOME = 'widgetsSurveyResults'

export enum MenuItems {
  headerAndLogo = 'Header & Logo',
  appearance = 'Appearance',
  results = 'Results Display',
  preview = 'Preview Options',
}

export const MenuSections: Types.MenuSection[] = [
  {
    icon: <HeaderLogo />,
    key: Utils.getEnumHash(MenuItems.headerAndLogo, MenuItems),
    value: MenuItems.headerAndLogo,
  },
  {
    icon: <MenuBrush />,
    key: Utils.getEnumHash(MenuItems.appearance, MenuItems),
    value: MenuItems.appearance,
  },
  {
    icon: <SettingsIcon svgwidth={27.5} svgheight={27.5} />,
    key: Utils.getEnumHash(MenuItems.results, MenuItems),
    value: MenuItems.results,
  },
  {
    icon: <SettingsIcon svgwidth={27.5} svgheight={27.5} />,
    key: Utils.getEnumHash(MenuItems.preview, MenuItems),
    value: MenuItems.preview,
  },
]

export const DEFAULT_CONFIGURATIONS = {
  survey_results_header_show: 'true',
  survey_results_page_title: 'Survey Results',
  survey_results_header_description: 'See how others responded to this survey. Results are updated in real-time.',
  survey_results_card_size: 'large',
  survey_results_border_color: '#dee2e6',
  survey_results_highlight_color: '#7FAE1B',
  survey_results_header_image_url: '',
  survey_results_header_text: '',
}